// This file is generated by pnpm icons:generate. Do not edit.

import {EnvelopeNotification_Filled_Corner2_Rounded as CanonicalEnvelopeNotification_Filled_Corner2_Rounded} from '../Envelope'

/** @deprecated Import EnvelopeNotification_Filled_Corner2_Rounded from `#/components/icons/Envelope` instead. */
export const EnvelopeNotification_Filled_Corner2_Rounded =
  CanonicalEnvelopeNotification_Filled_Corner2_Rounded
